import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PagesRoutingModule } from './pages-routing.module';
import { HomeComponent } from './home/home.component';
import { PqgridComponent } from './pqgrid.component';
// import { SearchFormComponent } from './home/search-form/search-form.component';
import {SharedModule} from '../shared/shared.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {WheelsListingComponent} from './wheels/wheels-listing/wheels-listing.component';
import {WheelFiltersComponent} from './wheels/wheel-filters/wheel-filters.component';
import {WheelDetailModalComponent} from './wheels/wheel-detail-modal/wheel-detail-modal.component';
import {WheelDetailModalRefactoredComponent} from './wheels/wheel-detail-modal/wheel-detail-modal-refactored.component';
import {WheelSingleComponent} from './wheels/wheel-single/wheel-single.component';
import {WheelsDetailComponent} from './wheels/wheels-detail/wheels-detail.component';
import { AlloyWheelsComponent } from './alloy-wheels/alloy-wheels.component';
import { LoginComponent } from './login/login.component';
import { ProcessOrderComponent } from './process-order/process-order.component';
import { ThankYouComponent } from './thank-you/thank-you.component';
import { CancelOrderComponent } from './cancel-order/cancel-order.component';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import {ImagePathPipe} from '../shared/pipes/image-path.pipe';
import {NgImageFullscreenViewModule} from 'ng-image-fullscreen-view';
import { WheelSpecificationsComponent } from './wheels/wheel-specifications/wheel-specifications.component';
import { InstallmentsComponent } from './installments/installments.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { FooterPagesComponent } from './footer-pages/footer-pages.component';
import { SearchComponent } from './search/search.component';
// import {LightboxModule} from 'ngx-lightbox/lightbox.module';

import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { ClearnceWheelsComponent } from './clearnce-wheels/clearnce-wheels.component';
import { GalleryComponent } from './home/gallery/gallery.component';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { UpperFooterComponent } from '../includes/upper-footer/upper-footer.component';
import { AllInOneComponent } from './landing-page/all-in-one/all-in-one.component';
import { OneWareHouseComponent } from './landing-page/one-ware-house/one-ware-house.component';
import { MyVendorsComponent } from './my-vendors/my-vendors.component';
import { LandingHeaderComponent } from './landing-page/landing-header/landing-header.component';
import { LandingBannerComponent } from './landing-page/landing-banner/landing-banner.component';
import { VendorLoginComponent } from './vendor-login/vendor-login.component';
import { DownloadsComponent } from './downloads/downloads.component';
import { Page404Component } from './page404/page404.component';
import { BrandComponent } from './brand/brand.component';
import { NewHomeComponent } from './new-home/new-home.component';
import { GetstartedComponent } from '../components/getstarted/getstarted.component';
import { FeatureComponent } from './feature/feature.component';

import { SuppliersComponent } from './suppliers/suppliers.component';
import { AccessoriesComponent } from './accessories/accessories.component';
import { AccessoriesDetailsComponent } from './accessories-details/accessories-details.component';
import { AddOnsComponent } from './alloy-wheels/add-ons/add-ons.component';
import { AccessoriesFiltersComponent } from './accessories/accessories-filters/accessories-filters.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { TutorialsComponent } from './tutorials/tutorials.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { NewProductsComponent } from './new-products/new-products.component';
import { LinksBoxComponent } from './new-products/links-box/links-box.component';

@NgModule({
  declarations: [
    HomeComponent,
    // SearchFormComponent,
    PqgridComponent,
    WheelsListingComponent,    WheelFiltersComponent,
    WheelDetailModalComponent,
    WheelDetailModalRefactoredComponent,
    WheelSingleComponent,
    WheelsDetailComponent,
    AlloyWheelsComponent,
    LoginComponent,
    ProcessOrderComponent,
    ThankYouComponent,
    CancelOrderComponent,
    WheelSpecificationsComponent,
    InstallmentsComponent,
    PrivacyPolicyComponent,
    FooterPagesComponent,
    SearchComponent,
    ClearnceWheelsComponent,
    GalleryComponent,
    LandingPageComponent,
    UpperFooterComponent,
    AllInOneComponent,
    OneWareHouseComponent,
    MyVendorsComponent,
    SuppliersComponent,
    LandingHeaderComponent,
    LandingBannerComponent,
    VendorLoginComponent,
    DownloadsComponent,
    Page404Component,
    BrandComponent,
    NewHomeComponent,
    GetstartedComponent,
    FeatureComponent,
    AccessoriesComponent,
    AccessoriesDetailsComponent,
    AddOnsComponent,
    AccessoriesFiltersComponent,
    ResetPasswordComponent,
    TutorialsComponent,
    ContactUsComponent,
    DashboardComponent,
    NewProductsComponent,
    LinksBoxComponent
  ],
  imports: [
    CommonModule,
    PagesRoutingModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    SlickCarouselModule,
    NgImageFullscreenViewModule,
    // LightboxModule
    NgbModule
  ],
  providers: [
    ImagePathPipe
  ]
})
export class PagesModule { }
